export default "__VITE_ASSET__239176d0__"